var _ = require('underscore');
var SaveAs = require('file-saverjs');
var Parser = require('json2csv');
var XLSX = require('xlsx');

const WIDTH_MAP = { S: 10, M: 20, L: 35, XL: 60 };

function jsonToCsv(options) {
    var opts = options;
    opts.withBOM = true;
    var array = ['a', 'b'];
    var listSeperator = array.toLocaleString().substring(1, 2); 
    opts.delimiter = listSeperator || ",";
    //var Parser = require('json2csv');
    //require("@babel/polyfill");
    var csv = Parser.parse(options.json, opts);
    //require('es6-object-assign').polyfill();
    csvFile = new Blob([csv], { type: "text/csv" });

    SaveAs(csvFile, options.filename);
}

function jsonToXlsx(options) {
    // Build header row from options.fields
    const headers = options.fields.map(f => f.label || f); // Use 'label' if available, else field name
    const fields = options.fields.map(f => f.value || f);  // Use 'value' if available, else field name

    const headerStyle = { 
        alignment: { wrapText: true, vertical: "center", horizontal: "left"},
        font: { sz: 12, bold: true }
    };
    const cellStyle = { 
        alignment: { wrapText: true },
        font: { sz: 12 }
    };
    
    // Build worksheet data: first row is headers, then map each record to field values (with style)
    const worksheetData = [
        headers.map(h => ({ v: h, s: headerStyle })),
        ...options.json.map(rec =>
            fields.map(field => ({ v: rec[field], s: cellStyle }))
        )
    ];

    // Use label to find the corresponding column and get columnWidth
    const columnWidths = headers.map(headerLabel => {
        const colObj = options.columns.find(col => col.label === headerLabel);
        const widthKey = colObj && colObj.columnWidth ? colObj.columnWidth : 'M';
        return { wch: WIDTH_MAP[widthKey] };
    });

    // Create worksheet and workbook
    const worksheet = XLSX.utils.aoa_to_sheet(worksheetData);
    worksheet['!cols'] = columnWidths;

    /* Force all cells to be text to avoid Excel interpreting as formula
    Object.keys(worksheet).forEach(key => {
        if (key[0] !== '!') {
            worksheet[key].t = 's';
        }
    }); */

    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, options.filename.substring(0, 31));
    var xlsxFile = XLSX.write(workbook, {bookType: "xlsx", type: "array"});
    var blob = new Blob([xlsxFile], {type: "application/octet-stream"});
    SaveAs(blob, options.filename + ".xlsx");
}

var save = function (options) {   
    _.each(options.json, function (rec) {
        _.each(rec, function (value, key) {
            if (_.isString(value) && value.length > 25000) {
                rec[key] = value.substring(0, 25000)+' ...';
            }
        });       
    });
    if (EY.Consultation.Lookups.Configuration.EnableXlsxDownload) {
        jsonToXlsx({ json: options.json, fields: options.fields, columns: options.columns, filename: options.fileName });
    } else {
        jsonToCsv({ json: options.json, fields: options.fields, filename: options.fileName + ".csv" });
    }
};

//var Export = Backbone.Model.extend({
//    defaults: {
//        query: {},
//        queryPath: "AggregateViaPost/Record",
//        fileName: "Global Consultation",
//        fields: [],
//        geographies: [],
//        recordType: {},
//        jsonData: {},
//        csv: {}
//    },
//    urlRoot: EY.Consultation.Lookups.API.Notification + 'export'
//});

//module.exports.send = function (options) {
//    var collection = options.collection;
//    var query = options.queries.findWhere({ selected: true }) || options.queries.get('');
//    collection.fetch(_.pick(query.attributes, ['aggregate', 'filter', 'select'])).done(function () {
//        save({ json: collection.toJSON(), fields: options.fields, fileName: options.fileName });
//    });
//};


module.exports.send = function (options) {
    var collection = options.collection;
    save({ json: collection.toJSON(), fields: options.fields, columns: options.columns, fileName: options.fileName });
};


// WEBPACK FOOTER //
// ./js/Modules/Service/ExportNode.js